import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import PropertyMap from 'components/Common/PropertyMap/PropertyMap'
import { PROPERTY_MAP_MARKER_TYPE } from 'constants/map'

interface Props {
  offer: App.VillaOffer
}

function VillasPageLocationMeta({
  offer,
}: Props) {
  const intl = useIntl()
  const markers: Array<App.MapMarker> = useMemo(
    () => [{
      id: offer.property.id,
      type: PROPERTY_MAP_MARKER_TYPE,
      latitude: offer.property.latitude,
      longitude: offer.property.longitude,
    }],
    [offer],
  )

  return (
    <Group fullWidth direction="vertical" gap={32}>
      <Heading variant="heading2">
        {intl.formatMessage({
          id: 'lYPouxLRrq',
          defaultMessage: 'Location',
          description: 'Section title for villa property location on offer page',
        })}
      </Heading>
      {markers.length > 0 && (
        <Group direction="vertical" gap={20}>
          <PropertyMap
            markers={markers}
            height={320}
            wrapperStyle={{
              height: 320,
            }}
          />
          {offer.property?.address && <BodyText variant="medium" weight="bold">
            {offer.property.address}
          </BodyText>}
        </Group>
      )}
    </Group>
  )
}

export default VillasPageLocationMeta
